var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.963,
    height: 24.44,
    viewBox: "0 0 30.963 24.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57124",
    "data-name": "Group 57124",
    transform: "translate(0 -44.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56558",
    "data-name": "Group 56558",
    transform: "translate(0 44.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56557",
    "data-name": "Group 56557",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25894",
    "data-name": "Path 25894",
    d: "M1.561,115.738V100.693c-.531.14-1.061.312-1.561.468v18.993a20.117,20.117,0,0,1,12.688.655,14.67,14.67,0,0,0-10.409-4.354A.734.734,0,0,1,1.561,115.738Z",
    transform: "translate(0 -96.589)",
    fill: "#1491ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25895",
    "data-name": "Path 25895",
    d: "M40.794,44.587,40.747,63.1a16.449,16.449,0,0,1,11.814,5.93V51.376A15.606,15.606,0,0,0,40.794,44.587Z",
    transform: "translate(-37.766 -44.587)",
    fill: "#1491ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25896",
    "data-name": "Path 25896",
    d: "M261.336,101.12v15.029a.733.733,0,0,1-.718.718,14.577,14.577,0,0,0-10.378,4.354v.016a20.086,20.086,0,0,1,12.657-.687V101.588A15.2,15.2,0,0,0,261.336,101.12Z",
    transform: "translate(-231.934 -96.984)",
    fill: "#1491ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25897",
    "data-name": "Path 25897",
    d: "M233.238,44.587a15.435,15.435,0,0,0-11.8,6.789V69.027a16.449,16.449,0,0,1,11.8-5.93Z",
    transform: "translate(-205.24 -44.587)",
    fill: "#1491ea"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.f2e2fba7d5daa7810857160aae21bdad.svg";
export { ForwardRef as ReactComponent };